import { APP_INITIALIZER, ApplicationConfig, DEFAULT_CURRENCY_CODE, ErrorHandler, PLATFORM_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {  HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TranslateLoader, USE_DEFAULT_LANG } from '@ngx-translate/core';
import { ApmErrorHandler } from '@elastic/apm-rum-angular';
import { init as initApm, ApmBase } from '@elastic/apm-rum';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import { API_BASE_URL } from './services/client.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

export function createApmInstance(): ApmBase {
  return initApm({
    serviceName: 'OAB-Angular-App',
    serverUrl: 'https://a0954be4997144dc9d206d97cdb0e974.apm.westeurope.azure.elastic-cloud.com:443',
    logLevel: 'debug',
    transactionSampleRate: 1.0,
    environment: 'oab-angular-local-dev',
  });
}

export function initializeApm(apm: ApmBase) {
  return () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(apm);
      }, 100);
    });
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideClientHydration(),
     provideNativeDateAdapter(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    { provide: USE_DEFAULT_LANG, useValue: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    {
      provide: 'APM_BASE',
      useFactory: createApmInstance,
    },
    { provide: ApmBase, useFactory: createApmInstance },

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApm,
      deps: ['APM_BASE'],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
      deps: [ApmBase],
    },
    {
      provide: API_BASE_URL,
      useFactory: (platformId: object) =>
        isPlatformBrowser(platformId) ? environment.apiBaseUrl : 'https://localhost:44320',
      deps: [PLATFORM_ID],
    },
    {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
    provideAnimationsAsync()
  ],
};
